export enum SidebarTypes {
    SET_OPEN_STATE = "SET_OPEN_STATE"
}

export interface SidebarOpenState extends ReduxAction {
    type: SidebarTypes.SET_OPEN_STATE;
    payload: boolean;
}
